import { ResponseType } from "../../Types/ServicesType/servicesType";
import {
  InsuranceClaimDetailsReportType,
  InsuranceClaimSummaryReportType,
  InsuranceWiseClaimReportType,
  ParamsType,
} from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()
const { reportsApi } = api;
export const insuranceClaimSummaryReport = async (
  params: ParamsType
): Promise<ResponseType<InsuranceClaimSummaryReportType[]>> => {
  const response = await instance.post(
    `${reportsApi.insuranceClaimSummaryReport}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};
export const insuranceClaimSummaryReportPdf = async (
  params: ParamsType
): Promise<ResponseType<{ file: string }>> => {
  const response = await instance.post(
    `${reportsApi.insuranceClaimSummaryReportPdf}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};
export const insuranceClaimSummaryReportExcel = async (
  params: ParamsType
): Promise<ResponseType<string>> => {
  const response = await instance.post(
    `${reportsApi.insuranceClaimSummaryReportExcel}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};

export const insurancWiseClaimReport = async (params: {
  startDate: string;
  endDate: string;
  insuranceType: string;
  receiver: string;
  payer: string;
}): Promise<ResponseType<InsuranceWiseClaimReportType[]>> => {
  const response = await instance.post(
    `${reportsApi.insuranceWiseClaimReport}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};
export const insurancWiseClaimReportPdf = async (
  params: {
    startDate: string;
    endDate: string;
    insuranceType: string;
    receiver: string;
    payer: string;
  }
): Promise<ResponseType<{ file: string }>> => {
  const response = await instance.post(
    `${reportsApi.insuranceWiseClaimReportPdf}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};
export const insurancWiseClaimReportExcel = async (
  params: {
    startDate: string;
    endDate: string;
    insuranceType: string;
    receiver: string;
    payer: string;
  }
): Promise<ResponseType<string>> => {
  const response = await instance.post(
    `${reportsApi.insuranceWiseClaimReportExcel}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};

export const insuranceClaimDetailsReport = async (
  params: ParamsType
): Promise<ResponseType<InsuranceClaimDetailsReportType[]>> => {
  const response = await instance.post(
    `${reportsApi.insuranceClaimDetailsReport}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};
export const insuranceClaimDetailsReportPdf = async (
  params: ParamsType
): Promise<ResponseType<{ file: string }>> => {
  const response = await instance.post(
    `${reportsApi.insuranceClaimDetailsReportPdf}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};
export const insuranceClaimDetailsReportExcel = async (
  params: ParamsType
): Promise<ResponseType<string>> => {
  const response = await instance.post(
    `${reportsApi.insuranceClaimDetailsReportExcel}`,
    {
      ...params,
      clinicId,
    }
  );
  return response.data;
};
